export default [
  {
    path: "/cryptoConfigurations/paymentProviders",
    component: () => import(/* webpackChunkName: "layout" */ "../layout"),

    children: [
      {
        path: ":id",
        props: true,
        name: "crypto.paymentProviders.show",
        component: () => import(/* webpackChunkName: "crypto.paymentProviders" */ "./show.vue"),
      },
    ],
  },
];
